import { makeQuery } from "utilities/makeQuery"
import { fetchApiJson } from "utilities/fetchApiJson"

/**
 * 
 * @param {{page?: number, perPage?: number, state?: string}} params
 * @returns 
 */
export async function getArchiveOfficesApi(params) {
  return await fetchApiJson(makeQuery('/api/archive-offices', params))
}
